jQuery(document).ready(function($){

    $(function() {
        $('.hamburger-icon').click(function(e) {
            e.preventDefault();
            $(this).toggleClass('active');
            $('.navbar-collapse').toggleClass('active');
        })
    })

    $('.home-carousel').owlCarousel({
        loop:true,
        margin:10,
        nav:false,
        dots:true,
        items:1,
        autoplay:true,
        lazyLoad:true
    })

    $(function() {
        $('.diagram-dots .diagram-dot').click(function(e){
            e.preventDefault();
            var dotId = $(this).attr('data-id');
    
            $('.diagram-dots .diagram-dot').removeClass('active');
            $('.diagram-content').removeClass('active');
    
            $(this).addClass('active');
            $("#"+dotId).addClass('active');
        })
    })

    $(function() {
        $('.diagram-dot.one').click(function(e){
            e.preventDefault();
            $('#dia-1').addClass('active');
            $('#dia-2').removeClass('active');
            $('#dia-3').removeClass('active');
        })
        $('.diagram-dot.two').click(function(){
            $('#dia-1').removeClass('active');
            $('#dia-2').addClass('active');
            $('#dia-3').removeClass('active');
        })
        $('.diagram-dot.three').click(function(){
            $('#dia-1').removeClass('active');
            $('#dia-2').removeClass('active');
            $('#dia-3').addClass('active');
        })
    })

    // Smooth scroll
    $('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .not('.tabs li a')
    .click(function(event) {
        // On-page links
        if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
            && 
            location.hostname == this.hostname
        ) {
            // Figure out element to scroll to
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?
            if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000, function() {

                // Callback after animation
                // Must change focus!
                var $target = $(target);
                $target.focus();

                if ($target.is(":focus")) { // Checking if the target was focused
                    return false;
                } else {
                        $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                        $target.focus(); // Set focus again
                    };
                });
            }
        }
    });
})